/*
 * Open/closed flags for overlays that are triggered in one place and
 * rendered in another (header → mini cart, product card → quick view,
 * keyboard → search palette, hamburger → mobile drawer), plus the ambient
 * art the backdrop shows. Each overlay owns its own data.
 */
import { defineStore } from 'pinia';

export const useUiStore = defineStore('ui', {
  state: () => ({
    miniCartOpen: false,
    quickViewId: null as string | null,
    paletteOpen: false,
    mobileNavOpen: false,
    /** Art behind the page — the focused tile or the product in view. */
    ambientArt: null as string | null,
  }),
  actions: {
    openMiniCart() {
      this.closeAll();
      this.miniCartOpen = true;
    },
    closeMiniCart() {
      this.miniCartOpen = false;
    },
    openQuickView(productId: string) {
      this.quickViewId = productId;
    },
    closeQuickView() {
      this.quickViewId = null;
    },
    openPalette() {
      this.closeAll();
      this.paletteOpen = true;
    },
    closePalette() {
      this.paletteOpen = false;
    },
    openMobileNav() {
      this.closeAll();
      this.mobileNavOpen = true;
    },
    closeMobileNav() {
      this.mobileNavOpen = false;
    },
    setAmbient(url: string | null) {
      this.ambientArt = url;
    },
    /** One overlay at a time — called on route change too. */
    closeAll() {
      this.miniCartOpen = false;
      this.quickViewId = null;
      this.paletteOpen = false;
      this.mobileNavOpen = false;
    },
  },
});
